// extracted by mini-css-extract-plugin
export default {"section":"header_section__dTMuB","contenedor":"header_contenedor__ydo7Z","back":"header_back__lpYzH","icon":"header_icon__Z0eri","imgContainer":"header_imgContainer__5QHFJ"};